import React from 'react';
import PropTypes from 'prop-types';
import './ProgressBar.css';

const ProgressBar = ({ currentStep, comboType }) => {
  // Step labels for different progress bar combinations
  const stepsCombo1 = ['About You', 'Username', 'Upload Photo'];
  const stepsCombo2 = ['Skin Type', 'Skin Concerns', 'Skin Sensitivity', 'Skin Tone', 'Skin UnderTone'];

  // Determine which steps array to use based on comboType prop
  const steps = comboType === 'combo1' ? stepsCombo1 : stepsCombo2;

  return (
    // updated progress bar logic (previously: ${currentStep > index + 1 ? 'active' : ''}`})   
    <div className="progress-bar-container">
      {/* Mapping over the steps to render each step in the progress bar */}
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div className="step-container">
            <div className={`progress-circle ${currentStep >= index + 1 ? 'active' : ''}`}>   
             {/* Display checkmark for completed steps or the step number for the current step */}
              {currentStep > index + 1 ? '✓' : index + 1}
            </div>
            <div className="step-name">{step}</div>
          </div>
          {/* Render a line between steps except after the last step */}
          {index < steps.length - 1 && (
            <div className={`progress-line ${currentStep > index + 1 ? 'active' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
// Defining prop types to ensure correct usage of ProgressBar component props
ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  comboType: PropTypes.oneOf(['combo1', 'combo2']).isRequired,
};

export default ProgressBar;